import { BasicEnumerable } from "../BasicEnumerable.js";
export const defaultIfEmpty = (source, defaultValue) => {
    function* generator() {
        let found = false;
        for (const value of source) {
            found = true;
            yield value;
        }
        if (!found) {
            yield defaultValue;
        }
    }
    return new BasicEnumerable(generator);
};
